module.exports = __webpack_public_path__ + "assets/5a18aad003952372f31f7f1ac93454cc.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/freespin/BgmFg.mp3
 ** module id = 243
 ** module chunks = 0
 **/